// extracted by mini-css-extract-plugin
export default {"f":"_0872226d84","main":"_29bba270f5","btn":"_36debcc841","w":"_733a75c835","h":"c35b20d471","lh25":"_2b556417c7","wb":"a16e5a7c87","b":"_6b78231404","bx":"_8af3e79168"};